export enum SupplierCustomerRepeat {
  Oneoff = 0,
  Repeat = 1
}
